module.exports = __webpack_public_path__ + "e1905c46efdc2e4e1c9c13b906c63672.png";